import * as XLSX from "xlsx";
import Papa from "papaparse";

export const parseXlsxFile = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = (e) => {
      const bufferArray = e.target.result;
      const workbook = XLSX.read(bufferArray, { type: "buffer" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      resolve(jsonData);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const getFileExtension = (file) => {
  const fileType = file.name.split(".").pop();
  return fileType;
};

export const parseCsvFile = async (file) => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true, // Assuming the CSV has headers
      complete: (results) => {
        resolve(results.data);
      },
      error: (error) => {
        reject(error);
      },
    });
  });
};

export const generateCSVFileForProducts = (products) => {
  const headers = [
    "_id",
    "sku",
    "BestSeller",
    "BoxCoverage",
    "BoxPrice",
    "BrandID",
    "BrandName",
    "CatID",
    "CatName",
    "Collection_Name",
    "Coverage_sqft",
    "DescriptionP1",
    "Finish",
    "IsmostViewed",
    "SubCatID",
    "SubCatName",
    "SuperCatID",
    "SuperCatName",
    "createdAt",
    "installation_method",
    "isAddon",
    "isClearence",
    "isDiscount",
    "length",
    "name",
    "newProduct",
    "price",
    "productPictures",
    "slug",
    "thickness",
    "updatedAt",
    "width",
  ];

  let csvContent = headers.join(",") + "\n";

  products.forEach((product) => {
    const row = [
      product._id || "",
      product.sku || "",
      product.BestSeller || "",
      product.BoxCoverage || "",
      product.BoxPrice || "",
      product.BrandID || "",
      product.BrandName || "",
      product.CatID || "",
      product.CatName || "",
      product.Collection_Name || "",
      product.Coverage_sqft || "",
      product.DescriptionP1 || "",
      product.Finish ? product.Finish.join(", ") : "", // Handle array
      product.IsmostViewed || "",
      product.SubCatID || "",
      product.SubCatName || "",
      product.SuperCatID || "",
      product.SuperCatName || "",
      product.createdAt || "",
      product.installation_method ? product.installation_method.join(", ") : "", // Handle array
      product.isAddon || "",
      product.isClearence || "",
      product.isDiscount || "",
      product.length || "",
      product.name || "",
      product.newProduct || "",
      product.price || "",
      product.productPictures ? product.productPictures.join(", ") : "", // Handle array
      product.slug || "",
      product.thickness || "",
      product.updatedAt || "",
      product.width || "",
    ];

    csvContent += row.map((field) => `"${field}"`).join(",") + "\n";
  });

  return csvContent;
};
